$(function () {

    const $partners = $('#partners');

    $partners.accordionjs({
        closeAble: true,
        closeOther: false,
        activeIndex: false,
    });

    const count = $partners.children().length;

    if (count <= 3) {
        $partners.find('.acc_head').trigger('click');  
    } else {
        $partners.find('li[data-is-basic="1"] .acc_head').trigger('click');
    }
});
